import Decimal from 'decimal.js';

/**
 * Safely creates a Decimal from a string or number, returning null if invalid
 * @param value - The string or number value to convert to Decimal
 * @param options - Optional configuration
 * @param options.allowInfinite - Whether to allow Infinity values (default: true)
 * @returns Decimal instance or null if conversion fails
 */
export const safeDecimal = (value: number | string, options: { allowInfinite?: boolean } = {}): Decimal | null => {
  const { allowInfinite = true } = options;

  try {
    const decimal = new Decimal(value);

    if (!allowInfinite && !decimal.isFinite()) {
      return null;
    }

    return decimal;
  } catch {
    return null;
  }
};
